import PropTypes from "prop-types";
import Content from "components/helpers/action-text/content";
import {valueFrom} from "lib/form";
import {useContent} from "lib/hooks";
import {isBlankHTML} from "lib/string";

function CaseSubmission({record = null}) {
  const allCategories = useContent("Cases", "Categories").split(", ");

  if(!record) { return <div className="text-center">None</div>; }

  const value = (name, defaultValue) => valueFrom({
    defaultValue,
    name,
    objects: [record]
  });
  const categories = value("categories", []);
  const content = value("content");

  return (
    <form onSubmit={(e) => e.preventDefault()}>
      <div className="input-group mb-3">
        <div className="input-group-prepend">
          <label className="input-group-text" htmlFor="cs-record-first-name">First Name</label>
        </div>
        <input
          className="form-control"
          disabled={true}
          id="cs-record-first-name"
          name="first_name"
          type="text"
          value={value("first_name")}
        />
      </div>
      <div className="input-group mb-3">
        <div className="input-group-prepend">
          <label className="input-group-text" htmlFor="cs-record-last-name">Last Name</label>
        </div>
        <input
          className="form-control"
          disabled={true}
          id="cs-record-last-name"
          name="last_name"
          type="text"
          value={value("last_name")}
        />
      </div>
      <div className="input-group mb-3">
        <div className="input-group-prepend">
          <label className="input-group-text" htmlFor="cs-record-email">Email</label>
        </div>
        <input
          className="form-control"
          disabled={true}
          id="cs-record-email"
          name="email"
          type="email"
          value={value("email")}
        />
      </div>
      <div className="input-group mb-3">
        <div className="input-group-prepend">
          <label className="input-group-text" htmlFor="cs-record-title">Title</label>
        </div>
        <input
          className="form-control"
          disabled={true}
          id="cs-record-title"
          name="title"
          type="text"
          value={value("title")}
        />
      </div>
      <div className="input-group mb-3">
        <div className="input-group-prepend">
          <label className="input-group-text" htmlFor="cs-record-categories">Categories</label>
        </div>
        <div className="form-control h-auto">
          {allCategories.map((category, index) => (
            <div key={category} className="custom-control custom-switch">
              <input
                checked={categories.includes(category)}
                className="custom-control-input"
                disabled={true}
                id={`cs-record-categories-${index}`}
                name="categories"
                type="checkbox"
              />
              <label className="custom-control-label" htmlFor={`cs-record-categories-${index}`}>{category}</label>
            </div>
          ))}
        </div>
      </div>
      <div className="input-group mb-3">
        <div className="input-group-prepend">
          <label className="input-group-text" htmlFor="cs-record-keywords">Keywords</label>
        </div>
        <input
          className="form-control"
          disabled={true}
          id="cs-record-keywords"
          name="keywords"
          type="text"
          value={value("keywords").join(", ")}
        />
      </div>
      <h3 className="text-center">Content</h3>
      {isBlankHTML(content) ? (
        <div className="text-center">Blank</div>
      ) : (
        <Content html={content} />
      )}
    </form>
  );
}

CaseSubmission.propTypes = {
  record: PropTypes.shape({
  })
};

export default CaseSubmission;
